import { useState, useEffect } from 'react';

/**
 * Subscribe to a CSS media query and re-render when it changes.
 * Returns a boolean indicating whether the query currently matches.
 */
const useMediaQuery = (query) => {
  const getMatch = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false;

  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    // Sync in case the query changed between render and effect
    setMatches(mql.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
};

/**
 * Convenience hook: true on the `lg` breakpoint (≥1024px) and up, where the
 * shell shows the fixed sidebar. Below this the sidebar becomes a drawer.
 */
export const useIsDesktop = () => useMediaQuery('(min-width: 1024px)');

export default useMediaQuery;
